// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VZC0","field":"styles_field__2jGlw","fieldCol":"styles_fieldCol__343zl","diffCol":"styles_diffCol__3Kopt","diff":"styles_diff__3VSfL"};